import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { GetKaroakeListAPI } from '../api/karoake/getkaroakelist/getkaroakelistapi';
import { GetKaroakeListRequest } from '../api/karoake/getkaroakelist/getkaroakelistrequest';
import { GetKaroakeListResponse } from '../api/karoake/getkaroakelist/getkaroakelistresponse';
import { UploadKaroakeAPI } from '../api/karoake/uploadkaroake/uploadkaroakeapi';
import { UploadKaroakeRequest } from '../api/karoake/uploadkaroake/uploadkaroakerequest';
import { UploadKaroakeResponse } from '../api/karoake/uploadkaroake/uploadkaroakeresponse';
import { APIProcessor } from '../processor/apiProcessor';
import { GetKaroakeListAPIProcessorImpl } from '../processor/getkaroakelistapiprocessor';
import { UploadKaroakeAPIProcessorImpl } from '../processor/uploadkaroakeapiprocessor';
import { ProcessorFactoryImpl } from './processorfactory';

export class KaroakeProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(KaroakeProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getUploadKaroakeDetails():APIProcessor<UploadKaroakeRequest, UploadKaroakeResponse>
    {
        this.logger.log("getUploadKaroakeDetails() invoked");
        return new UploadKaroakeAPIProcessorImpl(this.getContext(), new UploadKaroakeAPI(this.getHttpClient(), this.getContext()));
    }

    getKaroakeListDetails():APIProcessor<GetKaroakeListRequest, GetKaroakeListResponse>
    {
        this.logger.log("getKaroakeListDetails() invoked");
        return new GetKaroakeListAPIProcessorImpl(this.getContext(), new GetKaroakeListAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/karoakeprocessorfactory.tsx